import { getAdminRoutePermission } from '../../adminRoutes';

const editLink = getAdminRoutePermission((x) => x.flightCompanyEdit);
const newLink = getAdminRoutePermission((x) => x.flightCompanyNew);

export const flightCompanyListPermissions = {
    editLink,
    newLink,
};
